export default __webpack_public_path__ + "static/media/withdraw-reward-step3.042c5fa9.png";